import React from 'react';

interface Props {
  text: string;
  radius?: number;
  direction?: 'up' | 'down';
  svgRef?: React.RefObject<SVGSVGElement>;
}

export default function CircularText(props: Readonly<Props>) {
  const { svgRef, text, radius = 200, direction = 'up' } = props;
  const centerX = 250;
  const centerY = 250;
  const largeArcFlag = 1;
  const isUp = direction === 'up';
  const sweepFlag = isUp ? 1 : 0;
  const pathId = isUp ? 'circlePathUp' : 'circlePathDown';

  const d = `M ${centerX - radius},${centerY} 
                A ${radius},${radius} 0 ${largeArcFlag},${sweepFlag} 
                ${centerX + radius},${centerY}`;

  return (
    <svg ref={svgRef} width="500" height="500" viewBox="0 0 500 500">
      <path id={pathId} d={d} fill="none" stroke="transparent" />
      <text textAnchor="middle" fontSize="50" fontFamily="Poppins">
        <textPath xlinkHref={`#${pathId}`} startOffset="50%">
          {text}
        </textPath>
      </text>
    </svg>
  );
}

export const useSvgAsBase64 = (svgRef: React.RefObject<SVGSVGElement>) => {
  const [base64Image, setBase64Image] = React.useState<string | null>(null);
  React.useEffect(() => {
    if (svgRef.current) {
      const svg = svgRef.current;
      const svgString = new XMLSerializer().serializeToString(svg);
      const blob = new Blob([svgString], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 500;
        canvas.height = 500;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);

        const base64 = canvas.toDataURL('image/png');
        setBase64Image(base64);
      };
      img.src = url;
    }
  }, [svgRef]);

  return base64Image;
};
